// eslint-disable-next-line import/prefer-default-export
export const AES_SECRET_KEY = 'RUFTWUNPTk5FQ1RDRUJSTw==';
